export default __webpack_public_path__ + "static/media/manual-external.af1fd51e.svg";